import React from 'react';
import { WidgetConditionalFilter } from '@mm/state/model/WidgetModel';
import { PlusCircleIcon } from '@mm/icons';
import Button from '../../../../../../../common/buttons/DeprecatedButton/DeprecatedButton';
import { ConditionalLogicModeProps } from '../ConditionalLogic';
import { PrimaryButton } from '../../../../../../../common/buttons/PrimaryButton/PrimaryButton';

export const ConditionalLogicAttributes = (
  props: ConditionalLogicModeProps,
) => {
  const {
    setEditMode,
    conditionalFilters,
    editWidget,
    setEditWidget,
    setEditFilter,
    variables,
  } = props;

  const onRemoveFilter = (filter: WidgetConditionalFilter) => {
    setEditWidget({
      ...editWidget,
      conditionalFilters: conditionalFilters.filter(f => filter !== f),
    });
  };

  const onEditFilter = (filter: WidgetConditionalFilter) => {
    setEditFilter(filter);
    setEditMode('attribute-detail');
  };

  const onAddFilter = () => {
    setEditFilter(undefined);
    setEditMode('attribute-detail');
  };

  const variableNameForFilter = (filter: WidgetConditionalFilter) => {
    const variable = variables.find(
      v =>
        v.variableId === filter.variableId &&
        v.variableType === filter.variableType,
    );
    return variable ? variable.name : '';
  };

  return (
    <div className="widget-conditional-logic__sub-section">
      <div className="widget-conditional-logic__header-text">
        <Button
          text
          className="widget-conditional-logic__back-button"
          onClick={() => setEditMode('root')}
        >
          <i className="fas fa-chevron-left" />
        </Button>
        Attributes
      </div>
      <div className="widget-conditional-logic__instructions">
        Applied attributes:
      </div>
      <div className="widget-conditional-logic__item-content">
        {conditionalFilters.length === 0
          ? 'No attributes added'
          : conditionalFilters.map((f, i) => (
              <>
                {i > 0 && (
                  <div className="widget-conditional-logic__item-content-item-separator">
                    AND
                  </div>
                )}

                <Button
                  text
                  key={f.id || JSON.stringify(f)}
                  className="widget-conditional-logic__item-content-item"
                  onClick={() => onEditFilter(f)}
                >
                  {variableNameForFilter(f)}
                  <Button
                    text
                    className="widget-conditional-logic__item-content-item-action-button"
                    onClick={e => {
                      e.stopPropagation();
                      onRemoveFilter(f);
                    }}
                  >
                    <i className="fas fa-times" />
                  </Button>
                </Button>
              </>
            ))}
      </div>
      <PrimaryButton
        color="secondary-blue"
        className="widget-conditional-logic__add-button"
        onClick={onAddFilter}
        leftIcon={<PlusCircleIcon color="blue" />}
      >
        Add attribute
      </PrimaryButton>
      <PrimaryButton
        className="widget-conditional-logic__add-button"
        onClick={() => setEditMode('root')}
      >
        Done
      </PrimaryButton>
    </div>
  );
};
